import { BaseApiService } from '@/services/base-service';
import {
  SimpleType,
  BannerFilter, Banner, ApiPagination, BaseResponse,
} from '@/types';

const cities_mock = (): SimpleType[] => ([
  {
    text: 'Абаза',
    value: 'Абаза',
  },
  {
    text: 'Абакан',
    value: 'Абакан',
  },
  {
    text: 'Абдулино',
    value: 'Абдулино',
  },
  {
    text: 'Абинск',
    value: 'Абинск',
  },
  {
    text: 'Москва',
    value: 'Москва',
  },
  {
    text: 'New Antoniotown',
    value: 'New Antoniotown',
  },
]);

const regions_mock = (): SimpleType[] => ([
  {
    text: 'Центральный',
    value: 'Центральный',
  },
  {
    text: 'Северо-Западный',
    value: 'Северо-Западный',
  },
  {
    text: 'Юго-Западный',
    value: 'Юго-Западный',
  },
  {
    text: 'Hyattburgh',
    value: 'Hyattburgh',
  },
]);

interface Banners extends BaseResponse, ApiPagination {
  data: {
    items: Banner[],
  }
}

export class GlobalService extends BaseApiService {
  private readonly base_path = 'api/url/profile';

  async get_cities(): Promise<SimpleType[]> {
    return cities_mock();
  }

  async get_regions(): Promise<SimpleType[]> {
    return regions_mock();
  }

  async get_banners(filters: BannerFilter): Promise<Banners> {
    const url = '/banners';
    const payload = filters;

    const { data } = await this.http_client.get<Banners>(url, {
      params: {
        filters: payload.filters,
      },
    });

    return data;
  }

  async send_banner_id(id: number): Promise<Banners> {
    const url = `/banners/${id}/stats`;

    const { data } = await this.http_client.post<Banners>(url, {
      user_agent: window.navigator.userAgent ?? null,
    });

    return data;
  }

  /*
   * Добавление и удлаление избранных пунктом меню
   */
  async add_favorite(id: number): Promise<void> {
    const url = `${this.base_path}/favorites/${id}`;

    const data = await this.http_client.post<void>(url);
  }

  async delete_favorite(id: number): Promise<void> {
    const url = `${this.base_path}/favorites/${id}`;

    const data = await this.http_client.delete<void>(url);
  }
}
